// extracted by mini-css-extract-plugin
export var completionBody = "_jt-2";
export var completionCard = "_jt-0";
export var completionFooter = "_jt-3";
export var completionTitle = "_jt-1";